import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {gqlBillingParty} from '../getBillingParty.api';
import {PayingMemberCreate} from './createBillingParty.api';
import {BillingParty} from '../../../graphql/billing_party.datatypes';

interface CreateAdjustment {
    adjustment_type: number
    amount: number
    description: string
}

interface UpdateAdjustment {
    id: number
    adjustment_type: number
    amount: number
    description: string
}

export interface PayingMemberUpdate {
    __typename: undefined
    billingParty: undefined
    user: undefined
    user_id: undefined
    payments?: undefined
    automaticPayment?: undefined
    hasAutomaticPayment?: undefined

    id: number
    billing_party_id: undefined
    first_name: string
    last_name: string
    email: string
    address_line_1: string
    address_line_2: string
    city: string
    state: string
    zipcode: string
    country: string
    primary_phone: string
    primary_phone_code: string
    secondary_phone: string
    secondary_phone_code: string
    notes: string
    primary_paying_member: boolean
    is_group_leader: boolean
}


export interface UpdateBillingPartyInput {
    data: {
        id: number
        group_booking_id?: number
        credit_card_fee?: number
        credit_card_fee_paid?: boolean
        soft_cancelled?: boolean
        disabled?: boolean
        payments?: undefined
        comp_credit_eligible?: boolean

        payingMembers?: {
            create?: PayingMemberCreate[]
            update?: PayingMemberUpdate[]
            delete?: number[]
        }

        adjustments?: {
            create?: CreateAdjustment[]
            update?: UpdateAdjustment[]
            delete?: number[]
        }
    }
}

interface UpdateBillingPartyData {
    __typename?: string,
    updateBillingParty: BillingParty
}

export const UPDATE_BILLING_PARTY_MUTATION = gql`
    mutation updateBillingParty($data: UpdateBillingPartyInput!) {
        updateBillingParty(data: $data) {
            ${gqlBillingParty}
        }
    }
`;

export const updateBillingParty = () => useMutation<UpdateBillingPartyData, UpdateBillingPartyInput>(
  UPDATE_BILLING_PARTY_MUTATION,
  {
    update: updateCacheByType('BillingParty'),
  }
);

export default updateBillingParty;
